import PropTypes from 'prop-types'
import { useEffect } from 'react'
import Preview from 'features/creative/preview/Preview'
import { useDispatch, useSelector } from 'react-redux'
import {
  reset,
  resetImage,
  setAltText,
  setImage,
} from 'features/creative/add/asset/thumbnailSlice'
import ErrorText from 'components/form/ErrorText'
import TextArea from 'features/creative/add/common/TextArea'
import { inactiveAsset } from 'features/creative/add/build/buildCreativeSlice'
import Button from 'components/form/Button'
import ImageLibraryUpload from '../common/ImageLibraryUpload'
import { ImageSizes } from 'features/image/ImageSizes'

const Thumbnail = ({ disabled, errors }) => {
  const dispatch = useDispatch()
  const { url, name, size, alt } = useSelector(
    state => state.creative.assets.thumbnail
  )

  useEffect(
    () => () => {
      dispatch(reset())
    },
    [dispatch]
  )

  const handleImageUpload = selectedImages => {
    const [image] = selectedImages
    dispatch(setImage(image))
  }
  const onClickDelete = () => dispatch(resetImage())

  return (
    <div className="cont_material">
      <div className="group_material">
        <div className="box_material">
          <strong className="subtit_subject2">
            이미지형 &gt; 썸네일
            <Button
              size="small"
              disabled={disabled}
              onClick={() => {
                dispatch(inactiveAsset('thumbnail'))
              }}>
              삭제
            </Button>
          </strong>
          <div className="inner_material">
            <div className="material_item">
              <div className="tit_itemwrap">
                <strong className="tit_item">이미지</strong>
              </div>
              <div className="desc_item">
                <ImageLibraryUpload
                  handleImageUpload={handleImageUpload}
                  onClickDelete={onClickDelete}
                  maxCount={1}
                  requiredImageSize={[ImageSizes['450x450']]}
                  imageUrl={url}
                  imageName={name}
                  imageSize={size}
                  disabled={disabled}
                />
                <ErrorText error={errors?.url} />
              </div>
            </div>
            <div className="material_item">
              <div className="tit_itemwrap">
                <strong className="tit_item">이미지 설명</strong>
              </div>
              <div className="desc_item">
                <TextArea
                  className="box_textarea2 textarea_s"
                  maxLength={30}
                  value={alt}
                  placeholder="장애인 음성안내 정보를 입력하세요"
                  error={errors?.alt}
                  trim
                  disabled={disabled}
                  onValueChange={v => dispatch(setAltText(v))}
                />
                <ErrorText error={errors?.alt} />
              </div>
            </div>
          </div>
        </div>
        <Preview type="THUMBNAIL" data={{ image: { url, alt } }} />
      </div>
    </div>
  )
}

export default Thumbnail

Thumbnail.propTypes = {
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.shape({
    alt: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    url: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  }),
}
